import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectField } from '~admin/view/components/ui/form/fields/field-select.component';
import { ClientProfileType } from '~client/model/client-profile-type';
import { optionEnumeratorMapper } from '~common/components/select.helper';

interface Props {
  name: string;
}

export const ClientTypeDropdown: React.FunctionComponent<Props> = ({ name }) => {
  const { t } = useTranslation();

  return (
    <SelectField
      name={name}
      label={t('createEvent.clientDetails.dropdown.clientType.label')}
      options={optionEnumeratorMapper(
        ClientProfileType,
        t,
        'createEvent.clientDetails.dropdown.clientType.enum',
      )}
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/details/client-details/client-dropdowns/client-type-dropdown.component.tsx